export default __webpack_public_path__ + "static/media/gummy-coding.fda5993e.svg";